<div class="col pr-0">
  <div class="row">
    <jni-users-listing></jni-users-listing>
  </div>
</div>
